var React = require('react');

function PlusInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.25 5a1 1 0 0 0-1-1h-.5a1 1 0 0 0-1 1v3.75H5a1 1 0 0 0-1 1v.5a1 1 0 0 0 1 1h3.75V15a1 1 0 0 0 1 1h.5a1 1 0 0 0 1-1v-3.75H15a1 1 0 0 0 1-1v-.5a1 1 0 0 0-1-1h-3.75V5z","fill":"#1A1A1A"}));
}

PlusInline.defaultProps = {"viewBox":"0 0 20 20","width":"20","height":"20","fill":"none"};

module.exports = PlusInline;

PlusInline.default = PlusInline;
